import { getLogicalRing } from 'owa-config';
import getNetworkInfo from './getNetworkInfo';
import getUserType from './getUserType';
import { getLogger, createSessionDatapoint } from '../AriaWrapper';
import { AWTEventData } from '@aria/webjs-sdk';
import OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import { getUserConfiguration } from 'owa-session-store';
import {
    getServerVersion,
    getDag,
    getBackend,
    getForest,
    getApp,
    getClientId,
    BootType,
    getSessionId,
    getPhysicalRing,
    getHostApp,
    getHostedScenario,
    getLayout,
} from 'owa-config';
import { getDefaultFeatureFlags } from 'owa-feature-flags';
import isDevEnvironment from './isDevEnvironment';
import { AnalyticsOptions } from '../types/DatapointEnums';

export function logSessionDatapoint(
    analyticsOptions: AnalyticsOptions,
    token: string,
    userConfiguration: OwaUserConfiguration,
    IsEdu: boolean,
    bootType: BootType
): void {
    // we need to create a seperate datapoint for each event, because there is a bug
    // in the aria code which will force the events to be sent to the same tenant if
    // the event is the same instance
    const properties = {
        Features: JSON.stringify(getDefaultFeatureFlags()),
        ServiceVersion: getServerVersion(),
        Dag: getDag(),
        BootType: bootType,
        UserAgent: window.navigator.userAgent,
    };

    if (userConfiguration) {
        let userOptions = userConfiguration.UserOptions;
        let viewConfig = userConfiguration.ViewStateConfiguration;
        let Dimensions: any = {
            WindowWidth: window.innerWidth,
            WindowHeight: window.innerHeight,
        };
        if (window.screen) {
            Dimensions.ScreenWidth = window.screen.availWidth;
            Dimensions.ScreenHeight = window.screen.availHeight;
        }
        properties['Settings'] = JSON.stringify({
            ReadingPanePosition: userOptions.GlobalReadingPanePositionReact,
            ListViewType: userOptions.GlobalListViewTypeReact,
            FocusedEnabled: userOptions.IsFocusedInboxEnabled,
            FocusedInboxBits: viewConfig.FocusedInboxBitFlags,
            ListViewBits: viewConfig.ListViewBitFlags /* Date headers disabled */,
            FolderViewBits: viewConfig.GlobalFolderViewState,
            PreviewText: userOptions.ShowPreviewTextInListView,
            SenderOnTop: userOptions.ShowSenderOnTopInListView,
            InlinePreviews: userOptions.ShowInlinePreviews,
            HoverActions: viewConfig.MailTriageOnHoverActions,
            Ponts: userOptions.NewEnabledPonts,
            Theme: (userOptions.ThemeStorageId || '') + '|' + userOptions.IsDarkModeTheme,
            MasterCategories: (userConfiguration.MasterCategoryList.MasterList || []).length,
            IsEdu,
            NetworkInfo: getNetworkInfo(),
            Dimensions,
            AdMarket: userConfiguration.AdMarket,
            DisplayDensity: userOptions.DisplayDensityMode,
            ConsumerAdsExperiment: userOptions.ConsumerAdsExperimentMode,
            Domain: userConfiguration.SessionSettings.TenantDomain,
        });
        properties['Dates'] = JSON.stringify({
            OwaLogon: userOptions.FirstOWALogon,
            MailLogon: userOptions.FirstOWAReactMailLogon,
            PeopleLogon: userOptions.FirstOWAReactPeopleLogon,
            CalendarLogon: userOptions.FirstOWAReactCalendarLogon,
            MiniLogon: userOptions.FirstOWAReactMiniLogon,
            MailboxCreate: userConfiguration.MailboxCreateDate,
        });
    }
    // TODO WI OW:27772 log session end
    let e = createSessionDatapoint(properties);
    addCommonProperties(e, IsEdu);
    if (!isDevEnvironment(analyticsOptions)) {
        getLogger(token).logEvent(e);
    }
}

export function addCommonProperties(e: AWTEventData, isEdu: boolean) {
    const sessionSettings = getUserConfiguration().SessionSettings;
    e.properties['BEServer'] = getBackend();
    e.properties['MBXGuid'] = sessionSettings.MailboxGuid;
    e.properties['Forest'] = getForest();

    // in order to be GDPR complaint, we need to log the puid in UserInfo.Id
    // so we can scrub the user's data if they request it.
    // But we are still going to log in the Puid column for backwards compatibility
    e.properties['Puid'] = sessionSettings.UserPuid;
    e.properties['UserInfo.Id'] = sessionSettings.UserPuid;

    e.properties['ClientId'] = getClientId();
    e.properties['Ring'] = getLogicalRing();
    e.properties['UserType'] = getUserType(isEdu);
    e.properties['App'] = getApp();
    e.properties['Layout'] = getLayout();
    e.properties['TenantGuid'] = sessionSettings.ExternalDirectoryTenantGuid;
    e.properties['Session.Id'] = getSessionId();
    e.properties['PhysicalRing'] = getPhysicalRing();
    e.properties['Host'] = getHostApp();
    e.properties['HostedScenario'] = getHostedScenario();
}
